import axios from 'axios';
import jwtDecode from 'jwt-decode';
import React, { createContext, useEffect, useReducer } from 'react';

import moment from 'moment';
const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decodedToken = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;
  return decodedToken.exp > currentTime;
};

const getSession = () => {
  // const navigate = useNavigate();

  const token = sessionStorage.getItem('accessToken');

  if (!isValidToken(token)) {
    // navigate('/')
  }

  return token;
};
const jwtAuthHeader = {
  headers: {
    Authorization: 'Bearer ' + getSession(),
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'ADD_READER': {
      return { ...state };
    }

    default: {
      return { ...state };
    }
  }
};

const MerchantContext = createContext({
  loaded: !false,
  merchant: {},
  addReader: () => Promise.resolve(),
  getDashboard: () => {},
  getNewDashboard: () => {},
});

export const MerchantProvider = ({ settings, children }) => {
  const [state, dispatch] = useReducer(reducer, []);

  const addReader = async (phoneNumber, uuid) => {
    // // console.log('add reader .... got here????', phoneNumber, uuid);
    try {
      const response = await axios.post(
        'https://api.crediometer.com/api/v1/admin/merchant/add/reader',
        {
          phoneNumber,
          uuid,
        }
      );

      dispatch({
        type: 'ADD_READER',
        payload: {},
      });
    } catch (e) {
      // console.error(e);
    }
  };
  const getDashboard =  async (date) => {
    const startDate = moment(new Date(date.startDate)).format("YYYY-MM-DD[T00:00:00.000Z]");
    const endDate = moment(new Date(date.endDate)).format("YYYY-MM-DD[T00:00:00.000Z]");

    try {
      // // console.log('------------ kuje');
      const res = await axios.get(
        'https://api.crediometer.com/api/v1/admin/merchant/overview?startDate=' + startDate + '&&endDate=' + endDate,
        jwtAuthHeader
      );
      // // console.log('Best detective ---- ', res.data);
      dispatch({
        type: 'LOAD_SAVINGS',
        payload: res.data,
      });
    } catch (e) {
      // console.error(e);
    }
  };

  const getNewDashboard = async (date) => {
    try {
      // // console.log('------------ kuje new get new data ', date);
      const res = await axios.get(
        'https://api.crediometer.com/api/v1/admin/merchant/overview?date=' + date,
        jwtAuthHeader
      );
      // // console.log('Best detective ---- ', res.data);
      dispatch({
        type: 'LOAD_SAVINGS',
        payload: res.data,
      });
    } catch (e) {
      // console.error(e);
    }
  };

  useEffect(() => {
    // // console.log('cautions fee');
    // if(){
    getDashboard();
    // }else{
    //     getSavings();
    // }
  }, []);

  return (
    <MerchantContext.Provider
      value={{
        merchant: state.merchant ?? {},
        loaded: state.loaded ?? false,
        getDashboard,
        getNewDashboard,
        addReader,
      }}
    >
      {children}
    </MerchantContext.Provider>
  );
};

export default MerchantContext;
